import { CaretDownOutlined, CaretUpOutlined, FilterOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import { useTranslation } from 'react-i18next'

import {
  ContainerTable,
  CustomHeaderTable,
  DataCellWrapper,
  EffortWrapper,
  HeaderCelDate,
  HeaderCellWrapper,
  HeaderCellWrapperCustom,
  TableCustom,
  TableWrapper,
  Wrappertable,
} from '@/components/pages/ClientDevice/styles'
import { GetAttendanceTotalEmployeeByRangeDayResponse } from '@/types/apis/attendanceEmployee'
import { getName } from '@/utils/employee'

type Props = {
  responseAttendanceTotalEmployee?: GetAttendanceTotalEmployeeByRangeDayResponse
  responseAttendanceTotalEmployeeLoading?: boolean
  employeeFilter: boolean
  handleFilterEmployee: () => void
}

const AttendanceTotalEmployeeByRangeDayTable = ({
  responseAttendanceTotalEmployee,
  responseAttendanceTotalEmployeeLoading,
  employeeFilter,
  handleFilterEmployee,
}: Props) => {
  const { t } = useTranslation()
  const dataSource = responseAttendanceTotalEmployee?.employees ?? []
  const dataAttendance = responseAttendanceTotalEmployee?.clientDevices ?? []

  return (
    <ContainerTable>
      <Spin spinning={responseAttendanceTotalEmployeeLoading}>
        <TableWrapper>
          <EffortWrapper>{t('components.pages.attendanceEmployee.listReport.table.hour')}</EffortWrapper>
          <Wrappertable>
            <TableCustom>
              <tbody>
                <CustomHeaderTable>
                  <HeaderCelDate>{t('components.pages.attendanceEmployee.listReport.table.date')}</HeaderCelDate>
                  <HeaderCellWrapperCustom onClick={handleFilterEmployee}>
                    {t('components.pages.attendanceEmployee.listReport.table.id')}
                    <FilterOutlined style={{ marginLeft: 10 }} />
                    {employeeFilter ? (
                      <CaretUpOutlined style={{ marginLeft: 3 }} />
                    ) : (
                      <CaretDownOutlined style={{ marginLeft: 3 }} />
                    )}
                  </HeaderCellWrapperCustom>
                  <HeaderCellWrapper>
                    {t('components.pages.attendanceEmployee.listReport.table.fullName')}
                  </HeaderCellWrapper>
                  {dataAttendance?.map((item, index) => (
                    <HeaderCellWrapper key={index}>{item.name}</HeaderCellWrapper>
                  ))}
                  <HeaderCellWrapper>
                    {t('components.pages.attendanceEmployee.listReport.table.total')}
                  </HeaderCellWrapper>
                </CustomHeaderTable>
                {dataSource.map((employee, index) => (
                  <tr key={index}>
                    <DataCellWrapper>{}</DataCellWrapper>
                    <DataCellWrapper>{employee.id}</DataCellWrapper>
                    <DataCellWrapper position={'left'}>{getName(employee)}</DataCellWrapper>
                    {dataAttendance?.map((clientDevice, index) => (
                      <DataCellWrapper key={index}>
                        {employee.attendances
                          ?.find((attendance) => attendance.clientDeviceId === clientDevice.id)
                          ?.workingTime.toFixed(1)}
                      </DataCellWrapper>
                    ))}
                    <DataCellWrapper>
                      {employee.totalWorkingTime ? employee.totalWorkingTime.toFixed(1) : undefined}
                    </DataCellWrapper>
                  </tr>
                ))}
              </tbody>
            </TableCustom>
          </Wrappertable>
        </TableWrapper>
      </Spin>
    </ContainerTable>
  )
}
AttendanceTotalEmployeeByRangeDayTable.displayName = 'AttendanceTotalEmployeeByRangeDayTable'
export default AttendanceTotalEmployeeByRangeDayTable
